import {
    CHANGE_LOCALE
} from './constants';

import {
    CLEAR_CONTENT
} from '../../services/contentful/constants';

export function changeLocale(languageLocale) {
    return (dispatch) => {
        dispatch({type: CLEAR_CONTENT});
        dispatch({type: CHANGE_LOCALE, locale: languageLocale});
    };
}
